import { createClient } from "@supabase/supabase-js";

// Use environment variables if available, otherwise use the provided values
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://qwdoyczcbcpuvxyaehca.supabase.co";
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF3ZG95Y3pjYmNwdXZ4eWFlaGNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYzOTI0NTUsImV4cCI6MjA2MTk2ODQ1NX0.T8sYMj2eXZ2X41upRx63M26DCCjfSsCbeOlI8Ky8sgg";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase URL or Anon Key");
}

// Detect environment and set appropriate redirect URL
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
const redirectUrl = isLocalhost
  ? "http://localhost:3000/home"
  : "https://bramlo.com/home";

// Create Supabase client with environment-aware configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Automatically detect and use correct redirect URL based on environment
    redirectTo: redirectUrl,
    // Flow type for OAuth
    flowType: "pkce",
    // Persist session in localStorage
    persistSession: true,
    // Detect session from URL
    detectSessionInUrl: true,
  },
});
